// v2/hooks/useExchangeRates.js
import { useCallback, useEffect, useState } from 'react';
import { apiGet } from '../utils/api';
import { mapRates } from '../utils/mapAccount';

export default function useExchangeRates() {
  const [rates, setRates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const yenile = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const veri = await apiGet('/v2/exchange-rates/');
      setRates(mapRates(veri && veri.rates));
    } catch (e) {
      setError(e.message || 'Kurlar alinamadi');
      setRates([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { yenile(); }, [yenile]);

  // Urun fiyatlarinda kullanilan EUR kuru
  const eurRate = (rates.find((r) => r.code === 'EUR') || {}).rate || 0;

  // Kart basligindaki tarih: EUR'un tarihi (ana kur o)
  const guncelTarih = (rates.find((r) => r.code === 'EUR') || {}).rateDate || '';

  return { rates, eurRate, guncelTarih, loading, error, yenile };
}
